import api from './api';

/**
 * @param {string} levelId
 * @param {string} skillId
 * @param {string} testName
 * @param {string} qpvReferenceName
 * @returns {Promise<{
 *  test_id: string
 *  skill_id: string
 *  level_id: string
 *  test_name: string
 *  qpv_reference: string
 *  updated_at: string
 *  created_at: string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-postTests
 */
export default async function createNewTestComponent(levelId, skillId, testName, qpvReferenceName) {
    const { data } = await api.post(
        `/levels/${levelId}/skills/${skillId}/tests`, {
            test_name: testName,
            qpv_reference: qpvReferenceName
        }
    );

    return data;
}